export default "__VITE_ASSET__Cih8GzLn__"